import { Button, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useExpandedRows } from '../../contexts/expandedRowsContext'
import * as Styled from './styles'

export const ExpandButton = () => {
  const { t } = useTranslation()
  const { isAllExpanded, handleExpandCollapseAll } = useExpandedRows()

  return (
    <Styled.ButtonWrapper>
      <Button onClick={handleExpandCollapseAll} variant="text" icon="chevronsUpDown">
        <Text>{isAllExpanded ? t('reports.collapse_all') : t('reports.expand_all')}</Text>
      </Button>
    </Styled.ButtonWrapper>
  )
}
